import { render, staticRenderFns } from "./accountMenu2.vue?vue&type=template&id=15d51b93&scoped=true&"
import script from "./accountMenu2.vue?vue&type=script&lang=js&"
export * from "./accountMenu2.vue?vue&type=script&lang=js&"
import style0 from "./accountMenu2.vue?vue&type=style&index=0&id=15d51b93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d51b93",
  null
  
)

export default component.exports